import * as THREE from 'three'
import Resources from '~/service/experience/utils/Resources'
import NidoPart, {
  NidoPartParameters,
} from '~/service/experience/world/nido/parts/NidoPart'
import { Nido } from '~/service/experience/world/nido/Nido'
import {
  NidoSocketCode,
  NidoSocketId,
  NidoSocketType,
} from '~/service/experience/world/nido/enum'

export default class NidoSocket extends NidoPart {
  isCorner: boolean
  constructor(
    parent: Nido,
    scene: THREE.Group,
    resources: Resources,
    parameters: NidoPartParameters,
    isCorner: boolean,
    socketCode: NidoSocketCode,
    socketId: NidoSocketId
  ) {
    super(
      parent,
      scene,
      resources.models.socket,
      parameters,
      socketCode,
      socketId
    )

    this.isCorner = isCorner

    if (isCorner) {
      this.model.rotation.y = Math.PI
    }

    this.inverted = parameters.inverted

    if (parameters.inverted) {
      this.model.rotation.y = Math.PI
    }
  }

  invert() {
    if (this.inverted) {
      this.model.rotation.y = 0
      this.inverted = false
    } else {
      this.model.rotation.y = Math.PI
      this.inverted = true
    }
  }

  toJSON() {
    const json = super.toJSON()

    const obj = JSON.parse(json)
    obj.isCorner = this.isCorner

    return JSON.stringify(obj, null, '\t')
  }
}
